import { catchError } from "./catcher";
import { appendHeaders } from "./headers";
import { getBaseApiUrl } from "./stand";

export const getFileNameFromResponse = (response: Response) => {
  const contentDisposition = response.headers.get('Content-Disposition');

  if (!contentDisposition) return null;

  const filenameRegex = /filename\*?=(?:UTF-8''([^;]+)|"([^"]+)")/i;
  const matches = contentDisposition.match(filenameRegex);

  if (matches) {
    return decodeURIComponent(matches[1] || matches[2]);
  }

  return null;
};

export const fileFetch = async (url: string, options?: RequestInit & { customCache?: boolean }) => {
  const withOrigin = getBaseApiUrl() + url;

  let response = await fetch(withOrigin, {
    ...options,
    headers: appendHeaders(options?.headers),
  });

  if (!response.ok) {
    response = await catchError(response, withOrigin, options);
  }

  const blob = await response.blob();
  const fileName = getFileNameFromResponse(response);

  return {
    blob,
    fileName,
  };
};

export const downloadFile = (blob: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
};
